var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12617_47233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9949 7.55287V11.8145C13.9949 13.0196 13.0145 14 11.8094 14H2.19329C0.988219 14 0.0078125 13.0196 0.0078125 11.8145V7.55287C0.0078125 6.34779 0.988219 5.36739 2.19329 5.36739H3.77777C4.07953 5.36739 4.32414 5.612 4.32414 5.91376C4.32414 6.21552 4.07953 6.46013 3.77777 6.46013H2.19329C1.59076 6.46013 1.10055 6.95033 1.10055 7.55287V11.8145C1.10055 12.4171 1.59076 12.9073 2.19329 12.9073H11.8094C12.4119 12.9073 12.9022 12.4171 12.9022 11.8145V7.55287C12.9022 6.95033 12.4119 6.46013 11.8094 6.46013H10.2249C9.92318 6.46013 9.67857 6.21552 9.67857 5.91376C9.67857 5.612 9.92318 5.36739 10.2249 5.36739H11.8094C13.0145 5.36739 13.9949 6.34776 13.9949 7.55287ZM4.35487 3.27943C6.30757 1.34473 6.22813 1.36566 6.4487 1.23841L6.4614 10.2171C6.46184 10.5186 6.70637 10.7627 7.00777 10.7627H7.00856C7.31032 10.7623 7.55458 10.5174 7.55417 10.2156L7.54147 1.23855C7.7616 1.36561 7.67981 1.34217 9.64786 3.29222C9.86122 3.50557 10.2072 3.5056 10.4205 3.29222C10.6339 3.07883 10.6339 2.7329 10.4205 2.51954L8.54031 0.639371C7.69267 -0.208268 6.30691 -0.217966 5.44958 0.639371L3.58219 2.50676C3.36881 2.72014 3.36881 3.06607 3.58219 3.27943C3.79558 3.49279 4.14151 3.49282 4.35487 3.27943Z",
    fill: "#EE4B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12617_47233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.b77a4d4deb6ecb3790fa9dfa2cc91d2b.svg";
export { ForwardRef as ReactComponent };